/**
 * Empty polyfill stub — replaces Next.js polyfill-module for modern browsers.
 * Saves ~12–23 KiB. Aliased from next.config.js.
 */
